if (!customElements.get('collection-banner-carousel')) {
  customElements.define('collection-banner-carousel', class CollectionBannerCarousel extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.index = 0;
      this.interval = Number(this.dataset.interval) || 5000;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (this.slides.length < 2) return;

      this.querySelector('[data-previous]')?.addEventListener('click', () => {
        this.show(this.index - 1);
        this.restart();
      });

      this.querySelector('[data-next]')?.addEventListener('click', () => {
        this.show(this.index + 1);
        this.restart();
      });

      this.dots.forEach((dot, dotIndex) => {
        dot.addEventListener('click', () => {
          this.show(dotIndex);
          this.restart();
        });
      });

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());

      if (window.Shopify?.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          const selectedIndex = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
          if (selectedIndex >= 0) this.show(selectedIndex);
          this.stop();
        });

        this.addEventListener('shopify:block:deselect', () => this.start());
      }

      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    show(nextIndex) {
      this.index = (nextIndex + this.slides.length) % this.slides.length;

      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.querySelector('[data-slide-link]')?.setAttribute('tabindex', active ? '0' : '-1');
      });

      this.dots.forEach((dot, dotIndex) => {
        const active = dotIndex === this.index;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    start() {
      if (this.dataset.autoplay !== 'true' || this.reduceMotion || this.timer || window.Shopify?.designMode) return;
      this.timer = window.setInterval(() => this.show(this.index + 1), this.interval);
    }

    stop() {
      window.clearInterval(this.timer);
      this.timer = null;
    }

    restart() {
      this.stop();
      this.start();
    }
  });
}
